export default {
    Title: 'Tham số báo cáo',
    Year: 'Chọn kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    DecisionDateLabel: 'Ngày',
    ViewReport: 'Xem báo cáo',
    Cancel: 'Hủy',
    StepItems :{
      Step1: '1. Các văn bản pháp lý liên quan',
      Step4: '4. Chi phí đầu tư không tính vào giá trị tài sản hình thành qua đầu tư',
      Step5: '5. Giá trị tài sản cố định mới tăng', // sửa bug 61647 - kbnguyet
      Step6: '6. Giá trị tài sản lưu động bàn giao',
      Step7: '7. Giá trị vật tư, thiết bị tồn đọng',
      Step8: '8. Tình hình thanh toán và công nợ của dự án',
      Step9: '9. Thuyết minh, nhận xét, kiến nghị'
    }
  };
  